export const MODERATION_MESSAGE_MODAL_NAME = 'moderationMessage';
